export const subscribeApi = {
  getStatus: ({ deviceTokenId, domain }) => ({
    url: 'v2/:clientId/notification-subscription/status',
    method: 'post',
    params: { deviceTokenId, domain },
  }),
  update: ({ deviceTokenId, domain, action = 'subscribe' }) => ({
    url: 'v2/:clientId/notification-subscription/update',
    method: 'post',
    params: { deviceTokenId, domain, action },
  }),
}
